export const PRIZM_CURRENT_VERSION = '4.8.1';
